<template>
  <div >
    <div v-if="isPageLoaded">
    <nav-bar ref="form"/>
    <div v-if="banner !== null && banner.length >0" dir="ltr">
      <carousel
          class="pb-2"
          :autoplay="true"
          :dots="false"
          :loop="false"
          :items="1"
          :nav="false"
      >
        <div v-for="item in banner"
             :key="item.id">
          <!--          <a v-if="item.link != null" :href="item.link" target="_blank">-->
          <!--            <v-img :src="$replaceHttps(item.imageUrl)" alt="بنر" class="banner-img mx-5">-->
          <!--            </v-img>-->
          <!--          </a>-->
          <v-img :src="$replaceHttps(item.imageUrl)" alt="بنر" class="banner-img mx-5">
          </v-img>
        </div>
      </carousel>
    </div>
    <div class="sec-garay-bg py-5 ">
      <div class="container header-bg border-radius pattern-1 ">
        <div class="row ">
          <h5 class="text-blue col py-0">
            ماشین سازان اصلانیان
          </h5>
        </div>
      </div>
      <div class="container p-md-0">
        <div class="row ">
          <div class="col-12 col-sm-6 col-md-3" v-for="item in card" :key="item.id">
            <router-link :to="item.cardPath">
              <div class="card-bg border-radius py-4 pt-0">
                <div class="">
                  <v-img :src="getImgUrl(item.src)" class="mx-auto border-radius-productName " alt=""
                         height="150"></v-img>
                </div>
                <div class="pt-10 text-center">{{ item.text1 }}</div>
                <div class="pb-10 text-center">{{ item.text2 }}</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="sec-wight-bg py-5 ">
      <div class="container sec-garay-bg border-radius pattern-2">
        <div class="row ">
          <h5 class="text-blue col py-0">
            محصولات
          </h5>
          <router-link to="allProducts"><p class="text-left col more py-0"><a>مشاهده بیشتر</a></p></router-link>
        </div>
      </div>
      <div v-if="Products !== undefined && Products.length >0" class="container p-md-0 mt-3" dir="ltr">
        <carousel
            dir="ltr"
            :autoplay="false"
            :dots="true"
            :loop="false"
            :margin="20"
            :nav="false"
            :responsive="{0:{items:1},768:{items:2},1024:{items:3},1440:{items:4},2000:{items:5}}">
          <v-card v-for="item in Products" :key="item.id" class="rounded-xl">
            <router-link :to="{path:'productDetails',query:{productId:item.id}}">
              <div class="bg-Products white--text text-center border-radius-productName py-4">{{ item.productName }}
              </div>
              <div class="sec-garay-bg  p-4">
                <v-img :src="$replaceHttps(item.imageUrl)" class="mx-auto" width="150" height="150"></v-img>
              </div>
              <router-link to="allProducts">
                <div class="bg-product-btn white--text text-center border-radius-product-btn py-4 "><a>مشاهده بیشتر</a>
                </div>
              </router-link>
            </router-link>
          </v-card>
        </carousel>
      </div>
    </div>
    <div class="sec-garay-bg py-5 "><!--pattern-3-->
      <div class="container header-bg border-radius ">
        <div class="row ">
          <h5 class="text-blue col py-0">
            خدمات
          </h5>
          <router-link to="Services"><p class="text-left col more py-0"><a>مشاهده بیشتر</a></p></router-link>
        </div>
      </div>
      <div v-if="Services !== undefined && Services.length >0" class="container p-md-0">
        <carousel
            dir="ltr"
            :autoplay="false"
            :dots="true"
            :loop="false"
            :margin="20"
            :nav="false"
            :responsive="{0:{items:1,},768:{items:2},1024:{items:3}}">
          <div class="col-12  px-0" v-for="item in Services" :key="item.id">
            <router-link :to="{path:'servicesDetails',query:{ServiceDetailsId:item.id}}">
              <div class="card-bg border-radius py-4">
                <v-img :src="$replaceHttps(item.imageUrl)" class="mx-auto rounded-circle " alt="" width="170"
                       height="170"></v-img>
                <div class="pt-10 text-center">{{ item.productName }}</div>
              </div>
            </router-link>
          </div>
        </carousel>
      </div>
    </div>
    <div class="sec-wight-bg py-5 ">
      <div class="container sec-garay-bg border-radius">
        <div class="row ">
          <h5 class="text-blue col py-0">
            اخبار و مقالات
          </h5>
          <router-link to="BlogCategories">
            <p class="text-left col more py-0"><a>مشاهده بیشتر</a></p>
          </router-link>
        </div>
      </div>
      <div v-if="latestBlogPosts !== undefined && latestBlogPosts.length >0" class="container p-md-0" dir="ltr">
        <carousel
            dir="ltr"
            :autoplay="false"
            :dots="true"
            :loop="false"
            :margin="20"
            :nav="false"
            :responsive="{0:{items:1},768:{items:2},1024:{items:3}}">
          <div class="col-12 px-0 " v-for="item in latestBlogPosts " :key="item.id">
            <router-link :to="{path: 'BlogPostsdetails',query:{BlogPostDetail:item.id}}">
              <v-img :src="$replaceHttps(item.image)" class="mx-auto border-radius-productName " height="300px"></v-img>
            </router-link>
            <div class="sec-garay-bg border-radius-product-btn height-blog">
              <div class="pt-10 px-5 mb-5">{{ item.title }}</div>
              <div class="pt-10 px-5 gray-taxt overflow-hidden a " v-html="item.description"></div>
              <v-divider></v-divider>
              <div class="row">
                <div class="col text-center gray-taxt "><i class="fas fa-eye px-2"></i>{{ item.views }}</div>
                <div class="col text-center gray-taxt">{{ $moment(item.modifiedDate) }}<i class="fas fa-calendar-alt px-2"></i></div>
              </div>
            </div>
          </div>
        </carousel>
      </div>
    </div>
    <div class="sec-garay-bg py-5 ">
      <div class="container header-bg border-radius pattern-1">
        <div class="row ">
          <h5 class="text-blue col py-0">
            مشتریان ما
          </h5>
          <router-link to="ourcustomers"><p class="text-left col more py-0">مشاهده بیشتر</p></router-link>
        </div>
      </div>
      <div v-if="Customers !== undefined && Customers.length >0" class="container p-md-0" dir="ltr">
        <carousel
            :slideSpeed="100"
            :autoplayTimeout="850"
            :autoplay="true"
            :dots="true"
            :loop="false"
            :margin="20"
            :nav="false"
            :responsive="{0:{items:3,},768:{items:6},1024:{items:7},1440:{items:8},2000:{items:9}}"><!--:interval="interval"-->
          <div class="col-12 px-0" v-for="item in Customers" :key="item.id" >
            <div class="card-bg border-radius p-4" >
              <a :href="item.link" target="_blank">
                <v-img :src="$replaceHttps(item.imageUrl)" class="mx-auto" ></v-img>
              </a>
            </div>
          </div>
        </carousel>
      </div>
    </div>
    <footer-menu></footer-menu>
    </div>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import carousel from 'vue-owl-carousel';
import FooterMenu from "@/components/footer";

let _this = null;

export default {
  name: "HomePage",
  components: {FooterMenu, NavBar, carousel},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-خانه'
  },
  data: () => ({

    text: ' This is Live string to display trim method. ',
    dropdownItems: [{ text: "apple" }, { text: "orange" }, { text: "grape" }],
    str:"Welcome to Canada!",
    substr: "",
    banner: [],
    isPageLoaded: false,
    logo: 'logo.png',
    showLoaderDialog: false,
    card: [
      {id: 4, src: '222.png', text1: 'فروش ماشین های', text2: ' تزریق پلاستیک',cardPath :'servicesDetails?ServiceDetailsId=5'},
      {id: 3, src: '111.png', text1: 'خدمات تزریق', text2:  ' پلاستیک' ,cardPath :'servicesDetails?ServiceDetailsId=4'},
      {id: 2, src: '333.png', text1: 'ساخت انواع', text2: ' قالب' ,cardPath :'servicesDetails?ServiceDetailsId=3'},
      {id: 1, src: '1-img.jpg', text1: 'مشاوره در راه اندازی', text2: ' خط تولید' ,cardPath :'conference'},


    ],
    Services: [],
    Customers: [],
    Products: [],
    latestBlogPosts: []
  }),

  mounted() {
    this.getData()
    _this = this;
  },

  methods: {

    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },

    getData() {
      this.showLoaderDialog = true;

      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/Index", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            this.banner = json.banners.filter(x => x.isActive === true)
            console.log('...', this.banner)
            this.Services = json.services.filter(x => x.isActive === true)
            this.Customers = json.customers.filter(x => x.isActive === true)
            this.Products = json.products.filter(x => x.isActive === true)
            console.log(json.products.filter(x => x.isActive === true))
            this.latestBlogPosts = json.latestBlogPosts.filter(x => x.isActive === true)

            setTimeout(function (){
              _this.showLoaderDialog = false;
              _this.isPageLoaded = true

            }, 4000);


            console.log("this.latestBlogPosts")
            console.log(this.latestBlogPosts)
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>


</style>

